/**
 * Live Rewind controller
 * Show all Live Rewinds
 */

import { remove } from 'app/helpers/entity'
import { STREAMING_PROVIDER_TYPES } from 'app/core/constants'

// controller mixins
LiveRewindCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * LiveRewindCtrl controller
 *
 * @class LiveRewindCtrl
 * @memberof mwApp/service
 * @see mwApp/service
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/service.controller:LiveRewindCtrl
 */
/* @ngInject */
export default function LiveRewindCtrl ($scope, $uibModal, LiveRewind, LiveRewindChannel, authSvc, liveRewinds, scope) {
  var vm = this
  const Lrw = scope.chnl ? LiveRewindChannel : LiveRewind

  /**
   * Auth service
   *
   * @memberof mwApp/addLiveRewind.controller:LiveRewindCtrl
   * @type {Object}
   */
  vm.authSvc = authSvc

  /**
   * Streaming Provider types
   *
   * @memberof mwApp/addLiveRewind.controller:LiveRewindCtrl
   * @type {object}
   */
  vm.streaming_provider_types = angular.copy(STREAMING_PROVIDER_TYPES)

  $scope.getters = {
    caseInsensitiveName: function (row) {
      return row.channel.name.toLowerCase()
    },
    caseInsensitiveLRNName: function () {
      return '&mdash;'
    }
  }

  /**
   * Live Rewinds list
   *
   * @memberof mwApp/service.controller:LiveRewindCtrl
   * @name vm.liveRewinds
   * @type {models.LiveRewind[]}
   */
  if (!liveRewinds) {
    // get liveRewinds
    LiveRewind.loadAll()
      .to(vm.liveRewinds = [])
      .then(() => { $scope.loading = false })
  } else {
    vm.liveRewinds = liveRewinds
    $scope.loading = false
  }

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Delete live rewind
   *
   * @memberof mwApp/liveRewind.controller:LiveRewindCtrl
   * @param  {models.LiveRewind} lrw
   */
  vm.deleteLiveRewind = function (lrw) {
    lrw._delete(`Live Rewind for ${lrw.channel.name} channel deleted`)
      .then(remove(vm.liveRewinds)(lrw))
  }

  /**
   * Create live rewind
   *
   * @memberof mwApp/service.controller:LiveRewindCtrl
   * @function
   * @param  {models.LiveRewind} lrw
   * @param {Event} $event - jqLite event object
   */
  vm.addLiveRewind = vm.editLiveRewind = function (lrw, $event) {
    vm.stopEvent($event)

    var isNew = !lrw
    var initialLrw = angular.copy(lrw) // initial state
    $uibModal.open({
      templateUrl: 'components/services/views/addLiveRewind.html',
      controller: 'AddLiveRewindCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        lrw: function () {
          return !isNew
            ? lrw
            : new Lrw()
        },
        chnl: scope.chnl ? scope.chnl : null
      }
    }).result
      .then(
        function close (lrw) {
          if (isNew) {
            vm.liveRewinds.push(lrw)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialLrw, lrw) // restore catchup
          }
        }
      )
  }
}
